import { render } from "./TabProgression.vue?vue&type=template&id=41c6cc11&scoped=true&ts=true"
import script from "./TabProgression.vue?vue&type=script&lang=ts"
export * from "./TabProgression.vue?vue&type=script&lang=ts"

import "./TabProgression.vue?vue&type=style&index=0&id=41c6cc11&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c6cc11"]])

export default __exports__